import { Injectable } from '@angular/core';
 
interface CacheEntry {
  data: any;
  timestamp: number;
  ttl: number; // TTL in milliseconds (e.g., 5 minutes = 300000)
}
 
@Injectable({ providedIn: 'root' })
export class CacheService {
  private cache = new Map<string, CacheEntry>();
  private cleanupInterval: any;
 
  constructor() {
    // Run cleanup every 5 minutes
    this.cleanupInterval = setInterval(() => this.cleanup(), 5 * 60 * 1000);
  }
  // Store data in cache
  set(key: string, data: any, ttl: number = 300000): void {
    this.cache.set(key, { data, timestamp: Date.now(), ttl });
  }
 
  // Retrieve data from cache (returns null if missing)
  get(key: string): any | null {
    const entry = this.cache.get(key);
    if (!entry) return null;
 
    // Check if entry is expired
    const now = Date.now();
    if (now - entry.timestamp > entry.ttl) {
      this.cache.delete(key); // Remove expired entry
      return null;
    }
 
    return entry.data;
  }
 
  // Remove a single entry
  delete(key: string): void {
    this.cache.delete(key);
  }
 
  // Clear entire cache
  clear(): void {
    this.cache.clear();
  }
  /**
   * Removes expired entries from the cache
   */
  private cleanup(): void {
    const now = Date.now();
    for (const [key, entry] of this.cache.entries()) {
      if (now - entry.timestamp > entry.ttl) {
        this.cache.delete(key);
      }
    }
  }
}